<template>
	<div>
		<div class='float-mr_type'>
			<div class='hos_info'>
				<img class='hos_logo_big' :src='hosItem.hosLogoUrl' />
				<div class='hos_name'>{{hosItem.hosShortName}}</div>
				<router-link class='switch_btn' to="/hos-list">
					<van-button type="primary" size="small">更换医院</van-button>
				</router-link>
			</div>
			<div class='multi-hos_tips'>
				<div class='multi-hos_tips_content'>【提示】如果不是此院区，可</div>
				<div class='select_hos' @click="switchDistrict">【切换院区】</div>
			</div>

			<div class='mr_type_cell'>
				<div class='mrType_desc'>确保医院信息无误，选择下方服务项目</div>
				<div class='mr_cell' v-for="item in items" :key="item.code" @click="selectService(item.code)">
					<div :class='item.className'>
						<img v-if="item.code == 1" class='mr_item_icon' src='../assets/chm.svg' />
						<img v-if="item.code == 2" class='mr_item_icon' src='../assets/mr_express.svg' />
						<img v-if="item.code == 3" class='mr_item_icon' src='../assets/mr_look.svg' />
						<div class='mr_item_name'>{{item.desc}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	let hosId = '';
	let parentHosId;
	import { mapState,mapGetters } from 'vuex'
	export default {
		name: 'hosService',
		data() {
			return {
				// hosShortName: String,
				// items: [],
				// hosItem: {}
			}
		},
		created() {

			let wxId = localStorage.getItem('wxId');
			hosId = this.$route.params.hosId;
			parentHosId = this.$route.params.parentHosId;
			const params = {
				'wxId': wxId,
				'hosId': hosId
			}
				
			// this.getHbMrRecordType(params);
		this.$store.dispatch('getHbMrRecordType',params);
		},
		computed:{
			...mapState({
				hosShortName:state =>state.service.hosShortName,
				hosItem:state =>state.service.he,
				hmrts:state =>state.service.hmrts,
				result:state =>state.service.result
			}),
			...mapGetters([
				'items'
			])
		},
		watch:{
			// result(val) {
			// 	this.getHbMrRecordType(val);
			// }
		},
		methods: {
			// getHbMrRecordType(params) {
			// 	this.$server.getHbMrRecordType(params).then(res => {
			// 		if (res.result == 1) {
			// 			let hmrts = res.hmrts;
			// 			this.hos = res.he;
			// 			this.hosShortName = this.$util.normalString(res.he.hosShortName);
			// 			// let typeId;
			// 			if (hmrts.length == 1) {
			// 				// state.show = false;
			// 			} else {
			// 				var hmrtsList = new Array();
			// 				for (let i in hmrts) {
			// 					var obj = new Object();
			// 					obj.code = hmrts[i].code;
			// 					obj.desc = hmrts[i].desc;
			// 					if (hmrts[i].code == 1) {
			// 						obj.className = "mr_item1"
			// 					} else if (hmrts[i].code == 2) {
			// 						obj.className = "mr_item2"
			// 					} else if (hmrts[i].code == 3) {
			// 						obj.className = "mr_item3"
			// 					}
			// 					hmrtsList.push(obj);
			// 				}
			// 				// this.items = hmrtsList;
			// 				// this.hosItem = res.he;
			// 				// state.hosItem = res.he;
			// 			}
			// 		}
			// 	})
			// },
			// getHbMrRecordType(val){
			// 	if(val == 1){
			// 		let hmrts = this.$store.state.service.hmrts;
			// 		if (hmrts.length == 1) {
			// 			// state.show = false;
			// 		} else {
			// 			var hmrtsList = new Array();
			// 			for (let i in hmrts) {
			// 				var obj = new Object();
			// 				obj.code = hmrts[i].code;
			// 				obj.desc = hmrts[i].desc;
			// 				if (hmrts[i].code == 1) {
			// 					obj.className = "mr_item1"
			// 				} else if (hmrts[i].code == 2) {
			// 					obj.className = "mr_item2"
			// 				} else if (hmrts[i].code == 3) {
			// 					obj.className = "mr_item3"
			// 				}
			// 				hmrtsList.push(obj);
			// 			}
			// 			// this.items = hmrtsList;
			// 			// this.hosItem = res.he;
			// 			// state.hosItem = res.he;
			// 		}
			// 	}
			// },
			selectService(e) {
				let code = e;
				console.log(code)
				// this.$router.push({ path: '/apply', query: { typeId: code ,hosId:hosId}})
				this.$router.push('/apply/' + hosId + '/' + code)
			},
			switchDistrict(){
				// this.$router.push({ path: '/district', query: { hosId:parentHosId}})
				this.$router.push('/district/' + parentHosId)
			}
		}
	}
</script>

<style lang="less">
	body {
		background-color: #efeff4;
	}

	.hos_info {
		display: flex;
		flex-direction: column;
		width: 100%;
		background-color: #fff;
	}

	.hos_logo_big {
		width: 80px;
		height: 80px;
		margin: 10px auto;
		margin-top: 20px;
	}

	.hos_name {
		font-size: 17px;
		font-weight: bold;
		text-align: center;
	}

	.switch_btn {
		margin: 5px auto;
	}

	.mr_type_cell {
		margin-top: 10px;
		width: 100%;
		background-color: #fff;
		text-align: left;
	}

	.mrType_desc {
		font-size: 15px;
		color: #333;
		padding-top: 20px;
		text-align: center;
	}

	.mr_cell {
		width: 33.33336%;
		text-align: center;
		display: inline-block;
		margin-top: 10px;
		margin-bottom: 10px;
	}

	.mr_item3 {
		border: 1px solid #88ceff;
		background-color: #f7fdff;
		width: 86%;
		height: 80px;
		text-align: center;
		margin: 0 auto;
		align-self: center;
	}

	.mr_item1 {
		border: 1px solid #86d085;
		background-color: #f9fff9;
		width: 86%;
		height: 80px;
		text-align: center;
		margin: 0 auto;
		align-self: center;
	}

	.mr_item2 {
		border: 1px solid #ffc07e;
		background-color: #fffcfa;
		width: 86%;
		height: 80px;
		text-align: center;
		margin: 0 auto;
		align-self: center;
	}

	.mr_item_icon {
		width: 20px;
		height: 20px;
		margin-top: 10px;
	}

	.mr_item_name {
		font-size: 15px;
		margin-bottom: 10px;
	}

	.multi-hos_tips {
		background: #effbff;
		display: flex;
		display: -webkit-flex;
		/* Safari */
		padding: 10px;
	}

	.multi-hos_tips_content {
		color: #333;
		font-size: 15px;
	}

	.select_hos {
		color: #1aac19;
		font-size: 15px;
		font-weight: bold;
	}

	.weui-btn_mini {
		font-size: 14px;
		border-radius: 25%;
	}
</style>
